// extracted by mini-css-extract-plugin
module.exports = {"container":"di-z"};